/**
 * Records the view.
 */
var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

export default function recordView(mapObj, blayer, dlayer, sState) {

      const p = sState.viewPrice.toFixed(2);
      const v = parseFloat(parseFloat(p/100) * parseFloat(parseFloat(process.env.REACT_APP_VAT_RATE))).toFixed(2);
      const r = 0;

      const e = mapObj.getView().calculateExtent()

      if (dlayer !== '') { blayer = blayer+","+dlayer; }

      const abortController = new AbortController();
      const request = {   
        userid:sState.userid,
        accountid:sState.aid,
        product:blayer,
        userref:sState.userreference,
        projectname:sState.projectreference,
        price:p,
        royalty:r,
        vat:v,
        sessionid:sState.ident,
        extent:e,
      };
  
      let mounted = true;
      (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/order/view', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
  
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    
    })();

}
